import type { StepExample } from './types';

const SAMPLE_ORG_ID = '00000000-0000-4000-8000-000000000001';
const SAMPLE_ASSET_ID = '00000000-0000-4000-8000-0000000000aa';
const SAMPLE_LOG_ID = '00000000-0000-4000-8000-0000000000bb';
const SAMPLE_EVENT_ID = '00000000-0000-4000-8000-0000000000cc';
const SAMPLE_INCIDENT_ID = '00000000-0000-4000-8000-0000000000dd';

export const PIPELINE_STEP_EXAMPLES: Record<
  'lin' | 'adie' | 'ics' | 'de',
  StepExample
> = {
  lin: {
    input: {
      logId: SAMPLE_LOG_ID,
      serialNumber: 'IES20201014500017',
      tenantId: SAMPLE_ORG_ID,
      siteId: 'site-south-02',
      tenantAssetId: SAMPLE_ASSET_ID,
      messageType: 'config',
      topic: 'MAT-030296/config',
      receivedAt: '2026-06-25T11:50:59.147Z',
      payload: {
        // timestamp_local: '25/06/2026 14:51:02',
        // message: 'StatusNotification',
        // direction: 'Entrant',
        // type: 'Requête',
        // charge_box_id: 'IES20201014500017',
        // log_ocpp: {
        connectorId: 1,
        errorCode: 'NoError',
        status: 'Charging',
        timestamp: '2026-06-25T11:50:59.147Z',
        // },
      },
    },
    output: {
      logId: SAMPLE_LOG_ID,
      context: {
        receivedAt: '2026-06-25T11:50:59.147Z',
        occurredAt: '2026-06-25T11:50:59.147Z',
        tenantId: SAMPLE_ORG_ID,
        subtenantId: '',
        siteId: 'site-south-02',
        zoneId: '',
        tenantAssetId: SAMPLE_ASSET_ID,
        componentName: 'connector_ccs_1',
      },
      config: {
        protocolType: 'OCPP',
        parserId: 'ocpp16-status-notification',
      },
      events: [
        {
          eventType: 'INFO',
          category: 'CONNECTIVITY',
          state: 'CHARGING',
        },
      ],
      telemetries: [],
      metadata: {
        rawMessage:
          '{"connectorId":1,"errorCode":"NoError","status":"Charging"}',
        normalizerID: 'lin-metis-ocpp',
        normalizerVersion: '1.0.0',
      },
    },
  },
  adie: {
    input: {
      log_id: SAMPLE_LOG_ID,
      context: {
        received_at: '2026-06-25T11:50:59.147Z',
        occurred_at: '2026-06-25T11:50:59.147Z',
        tenant_id: SAMPLE_ORG_ID,
        site_id: 'site-south-02',
        tenant_asset_id: SAMPLE_ASSET_ID,
        component_name: 'connector_ccs_1',
      },
      config: {
        protocol_type: 1,
        parser_id: 'ocpp16-status-notification',
      },
      telemetries: [
        {
          parameter: 1,
          value: 228.5,
          unit: 2,
          direction: 1,
          measure_type: 1,
          measurement_point: 'L1',
        },
      ],
      metadata: {
        normalizer_id: 'lin-metis-ocpp',
        normalizer_version: '1.0.0',
      },
    },
    output: {
      log_id: SAMPLE_LOG_ID,
      anomaly_event: [
        {
          log_id: SAMPLE_LOG_ID,
          event_id: SAMPLE_EVENT_ID,
          occurred_at: '2026-06-25T11:50:59.147Z',
          component_name: 'connector_ccs_1',
          telemetries: [
            {
              parameter: 1,
              value: 228.5,
              unit: 2,
              direction: 1,
              measure_type: 1,
              measurement_point: 'L1',
            },
          ],
          reason: 'Voltage above normal working range',
          tenant_asset_id: SAMPLE_ASSET_ID,
          session_id: 'sess-001',
          connector_id: '1',
          connector_type: 'DC',
        },
      ],
    },
  },
  ics: {
    input: {
      logs: [
        {
          log_id: SAMPLE_LOG_ID,
          context: {
            receivedAt: '2026-06-25T11:50:59.147Z',
            occurredAt: '2026-06-25T11:50:59.147Z',
            tenantId: SAMPLE_ORG_ID,
            siteId: 'site-south-02',
            tenantAssetId: SAMPLE_ASSET_ID,
          },
          config: { protocol_type: 1, parser_id: 'ocpp16-status-notification' },
          event: [
            {
              eventType: 'ERR',
              category: 'POWER_OPS',
              state: 'FAULTED',
            },
          ],
          metadata: {
            normalizer_id: 'lin-metis-ocpp',
            normalizer_version: '1.0.0',
          },
        },
      ],
      anomaly_events: [
        {
          log_id: SAMPLE_LOG_ID,
          event_id: SAMPLE_EVENT_ID,
          occured_at: '2026-06-25T11:50:59.147Z',
          component_name: 'connector_ccs_1',
          reason: 'Voltage above normal working range',
          tenantAssetId: SAMPLE_ASSET_ID,
          siteId: 'site-south-02',
          tenantId: SAMPLE_ORG_ID,
          sessionId: 'sess-001',
          connectorId: '1',
          connectorType: 'DC',
          telemetries: [],
        },
      ],
      relations: [],
    },
    output: {
      results: [
        {
          source_id: SAMPLE_EVENT_ID,
          success: true,
          message: 'Processed successfully',
          incident_id: SAMPLE_INCIDENT_ID,
          correlation_status: 'NEW',
          incident: {
            incident_id: SAMPLE_INCIDENT_ID,
            start_time: '2026-06-25T11:50:59.147Z',
            end_time: '2026-06-25T11:50:59.147Z',
            duration_seconds: 0,
            dominant_event_severity: 'ERR',
            scope: 'ASSET',
            assets_affected: [SAMPLE_ASSET_ID],
            sites_affected: ['site-south-02'],
            tenants_affected: [SAMPLE_ORG_ID],
            categories: ['POWER_OPS'],
            components_involved: ['connector_ccs_1'],
            kg_components: [],
            events_count: 1,
            severity: {
              level: 'S2',
              score: 72,
              details: {
                event_type_score: 80,
                dominant_event_severity: 'ERR',
                category_score: 70,
                critical_category: 'POWER_OPS',
                composite_score: 72,
              },
              justification:
                'Composite score driven by ERR event on POWER_OPS category.',
            },
            priority: { level: 'P2' },
            events: [
              {
                event_id: SAMPLE_EVENT_ID,
                log_id: SAMPLE_LOG_ID,
                incident_id: SAMPLE_INCIDENT_ID,
                occurred_at: '2026-06-25T11:50:59.147Z',
                tenant_id: SAMPLE_ORG_ID,
                asset_id: SAMPLE_ASSET_ID,
                site_id: 'site-south-02',
                component_type: 'connector_ccs_1',
                event_severity: 'ERR',
                event_type: 'NOTIFICATION',
                event_category: 'POWER_OPS',
                event_state: 'FAULTED',
                found_in_kg: false,
                kg_neighbors: [],
                incident_severity: 'S2',
                incident_priority: 'P2',
              },
            ],
          },
        },
      ],
    },
  },
  de: {
    input: {
      incident_id: SAMPLE_INCIDENT_ID,
      start_time: '2026-06-25T11:50:59.147Z',
      end_time: '2026-06-25T11:50:59.147Z',
      duration_seconds: 0,
      dominant_event_severity: 'ERR',
      scope: 'ASSET',
      assets_affected: [SAMPLE_ASSET_ID],
      sites_affected: ['site-south-02'],
      tenants_affected: [SAMPLE_ORG_ID],
      categories: ['POWER_OPS'],
      components_involved: ['connector_ccs_1'],
      kg_components: [],
      events_count: 1,
      severity: { level: 'S2', score: 72 },
      priority: { level: 'P2' },
      processing_mode: 'sandbox',
      events: [
        {
          event_id: SAMPLE_EVENT_ID,
          log_id: SAMPLE_LOG_ID,
          incident_id: SAMPLE_INCIDENT_ID,
          occurred_at: '2026-06-25T11:50:59.147Z',
          asset_id: SAMPLE_ASSET_ID,
          component_type: 'connector_ccs_1',
          event_severity: 'ERR',
          event_type: 'NOTIFICATION',
          event_category: 'POWER_OPS',
          event_state: 'FAULTED',
          found_in_kg: false,
          kg_neighbors: [],
        },
      ],
    },
    output: {
      diagnosisId: '00000000-0000-4000-8000-0000000000ee',
      incidentId: SAMPLE_INCIDENT_ID,
      assetId: [SAMPLE_ASSET_ID],
      targetComponentId: 'connector_ccs_1',
      diagnosedAt: '2026-06-25T12:00:00Z',
      diagnosisDurationMs: 42,
      summary: 'Grid Surge / Utility Overvoltage detected on connector_ccs_1.',
      version: {
        engineVersion: '2.0.0',
        assetTypeRulePackVersion: 'EVSE-1.0.0',
      },
      rootCauseAnalysis: {
        rootCause: 'Grid Surge / Utility Overvoltage',
        confidence: 0.93,
        method: 'deterministic_rule',
        evidenceChain: [
          {
            type: 'log_pattern',
            source: 'connector_ccs_1',
            observation: 'Voltage above normal working range on L1',
            timestamp: '2026-06-25T11:50:59.147Z',
          },
        ],
        differentialDiagnosis: [],
      },
      remediation: {
        escalationPath: 'manual_review',
        actions: [
          {
            actionDisplayId: 'act_001',
            actionType: 'remote_stop',
            actionDescription: 'Stop charging on affected connector via OCPP',
            targetComponentId: 'connector_ccs_1',
            remote: true,
            onFailure: 'abort_and_escalate',
            riskLevel: 'disruptive',
            rationale:
              'Recommended action for: Grid Surge / Utility Overvoltage',
          },
        ],
      },
    },
  },
};
